module.exports = __webpack_public_path__ + "static/img/hud_right_bottom_corn.a88b7148.png";